function setWindowSize() {
  document.documentElement.style.setProperty(
    '--window-inner-height',
    `${window.innerHeight}px`,
  );
}

function allowWindowResize() {
  document.documentElement.style.setProperty(
    '--window-inner-height',
    'auto',
  );
}

function disableWindowResize() {
  if (getComputedStyle(document.documentElement).getPropertyValue('--window-inner-height') === 'auto') {
    setWindowSize();
  }
}

export {
  setWindowSize,
  allowWindowResize,
  disableWindowResize,
};
